"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import SideDrawerStore from 'Stores/SideDrawerStore';
import { sideDrawerUpdateWidth, sideDrawerClose } from 'Actions/ApplicationActions';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SideDrawerList from '../SideDrawer/SideDrawerList';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import CustomResizableBox from 'Components/CustomResizableBox';
import { user } from "Models/UserModel";
import classNames from "classnames";
import { BUILD_VARS } from 'Build_vars';
import { getSystemParam } from "D5Utils/functions";

var styles = function styles(theme) {
  return {
    drawerPaper: {
      width: '100%',
      position: 'relative'
    },
    drawerRoot: {
      height: '100%'
    },
    drawerHeader: {
      height: '44px',
      minHeight: '44px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px',
      background: theme.palette.customColors.drawer.header.bg,
      color: theme.palette.customColors.drawer.header.color
    },
    drawerTitleDiv: {
      width: '100%',
      padding: '0 8px'
    },
    drawerTitle: {
      display: 'block',
      textDecoration: 'none',
      color: 'inherit',
      textAlign: 'center',
      '&:hover': {
        textDecoration: 'underline',
        color: theme.palette.customColors.drawer.header.titleHover
      }
    },
    iconStyle: {
      width: '38px',
      height: '38px',
      padding: 0
    },
    titleStyle: {
      fontSize: '1.2rem'
    },
    version: {
      textAlign: 'end',
      paddingRight: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit / 2,
      color: theme.palette.customColors.drawer.version
    }
  };
};

var SideDrawer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SideDrawer, _React$Component);

  function SideDrawer(props) {
    var _this;

    _classCallCheck(this, SideDrawer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideDrawer).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isMobile", false);

    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = SideDrawerStore.getList();
    _this._onWindowResize = _this._onWindowResize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(SideDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isMobile = document.body.clientWidth <= this.props.theme.breakpoints.values.md;

      if (this.isMobile) {
        setTimeout(function () {
          return sideDrawerClose();
        });
      }

      $(window).on('resize', this._onWindowResize);
      SideDrawerStore.doLoadSubsystems();
      SideDrawerStore.addChangeListener(this._onChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(window).off('resize', this._onWindowResize);
      SideDrawerStore.removeChangeListener(this._onChange);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var drawerWidth = this.props.drawerWidth;
      return !(drawerWidth && nextProps.drawerWidth !== drawerWidth);
    }
  }, {
    key: "_onWindowResize",
    value: function _onWindowResize() {
      var w = document.body.clientWidth;

      if (w <= this.props.theme.breakpoints.values.md) {
        if (!this.isMobile) {
          this.isMobile = true;
          sideDrawerClose();
        }
      } else {
        if (this.isMobile) {
          this.isMobile = false;
          sideDrawerClose();
        }
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange() {
      this.setState(SideDrawerStore.getList());
    }
  }, {
    key: "handleSideDrawerClose",
    value: function handleSideDrawerClose() {
      sideDrawerClose();
    }
  }, {
    key: "_onResize",
    value: function _onResize(e, _ref) {
      var size = _ref.size;
      setTimeout(function () {
        return sideDrawerUpdateWidth(size.width);
      });
    }
  }, {
    key: "_onResizeStop",
    value: function _onResizeStop(e, _ref2) {
      var size = _ref2.size;
      localStorage.setItem("".concat(user.getUserID(), "-theme-drawerWidth"), size.width);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          theme = _this$props.theme,
          drawerWidth = _this$props.drawerWidth,
          drawerAnchor = _this$props.drawerAnchor,
          drawerOpen = _this$props.drawerOpen;
      var userScriptVer = window.USER_SCRIPTS_BUILD_VARS && window.USER_SCRIPTS_BUILD_VARS.USER_SCRIPT_VER;
      return React.createElement(Drawer, {
        variant: !this.isMobile ? "persistent" : "temporary",
        anchor: drawerAnchor,
        open: drawerOpen,
        classes: {
          paper: classes.drawerPaper,
          root: classes.drawerRoot
        },
        PaperProps: {
          component: function component(props) {
            return React.createElement(CustomResizableBox, {
              width: drawerOpen ? drawerWidth : 0,
              height: document.documentElement.clientHeight,
              axis: "x",
              direction: drawerAnchor,
              onResize: _this2._onResize,
              onResizeStop: _this2._onResizeStop,
              minConstraints: [240, document.documentElement.clientHeight],
              maxConstraints: [500, document.documentElement.clientHeight],
              tabIndex: "-1"
            }, React.createElement(Paper, props, props.children));
          }
        }
      }, React.createElement("div", {
        className: classes.drawerHeader
      }, React.createElement("div", {
        className: classes.drawerTitleDiv
      }, React.createElement("a", {
        href: "#",
        className: classes.drawerTitle
      }, React.createElement(Typography, {
        className: classes.titleStyle,
        variant: "h6",
        color: "inherit"
      }, getSystemParam('MainForm', 'Title')))), React.createElement(IconButton, {
        className: classNames(classes.iconStyle),
        onClick: this.handleSideDrawerClose,
        color: 'inherit'
      }, theme.direction === 'rtl' ? React.createElement(ChevronRightIcon, null) : React.createElement(ChevronLeftIcon, null))), React.createElement(Divider, null), React.createElement(SideDrawerList, null), React.createElement(Typography, {
        className: classes.version,
        style: {
          paddingBottom: 0
        },
        variant: "caption"
      }, BUILD_VARS.CORE_VERSION), React.createElement(Typography, {
        className: classes.version,
        variant: "caption"
      }, userScriptVer || BUILD_VARS.USER_SCRIPT_VER));
    }
  }]);

  return SideDrawer;
}(React.Component);

_defineProperty(SideDrawer, "propTypes", {
  classes: PropTypes.object.isRequired,
  drawerWidth: PropTypes.number.isRequired,
  drawerAnchor: PropTypes.string.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired
});

export default withStyles(styles, {
  withTheme: true
})(SideDrawer);